module.exports = __webpack_public_path__ + "img/Menu-05.87b02276.png";